<template>
  <div class="card mt-3">
    <header class="card-header">
      <p class="card-header-title has-background-info-light has-text-info-dark">
        Nadolazeće škrinje
      </p>
    </header>
    <div class="card-content">
      <div class="table-container">
        <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
          <thead>
            <tr>
              <th>Ime</th>
              <th>#</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="kutija in kutije" :key="kutija.index">
              <td
                v-if="kutija.name.startsWith('Magic')"
                class="has-background-danger-light has-text-danger-dark"
              >
                {{ kutija.name }}
              </td>
              <td
                v-else-if="kutija.name.startsWith('Epic')"
                class="has-background-danger-dark has-text-white"
              >
                {{ kutija.name }}
              </td>
              <td
                v-else-if="kutija.name.startsWith('Golden')"
                class="has-background-warning-light has-text-warning-dark"
              >
                {{ kutija.name }}
              </td>
              <td
                v-else-if="kutija.name.startsWith('Giant')"
                class="has-background-warning-dark has-text-light"
              >
                {{ kutija.name }}
              </td>
              <td
                v-else-if="kutija.name.startsWith('Legendary')"
                class="has-background-info has-text-warning"
              >
                {{ kutija.name }}
              </td>
              <td
                v-else-if="kutija.name.includes('Light')"
                class="has-background-info-light has-text-info-dark"
              >
                {{ kutija.name }}
              </td>
              <td
                v-else-if="kutija.name.includes('Crate')"
                class="has-background-warning"
              >
                <strong class="has-text-warning-dark">
                  {{ kutija.name }}
                </strong>
              </td>
              <td
                v-else-if="kutija.name.includes('Wild')"
                class="has-background-info-dark"
              >
                <strong class="has-text-warning">
                  {{ kutija.name }}
                </strong>
              </td>
              <td v-else>{{ kutija.name }}</td>
              <td
                v-if="kutija.name.startsWith('Magic')"
                class="has-background-danger-light has-text-danger-dark"
              >
                {{ kutija.index }}
              </td>
              <td
                v-else-if="kutija.name.startsWith('Epic')"
                class="has-background-danger-dark has-text-white"
              >
                {{ kutija.index }}
              </td>
              <td
                v-else-if="kutija.name.startsWith('Golden')"
                class="has-background-warning-light has-text-warning-dark"
              >
                {{ kutija.index }}
              </td>
              <td
                v-else-if="kutija.name.startsWith('Giant')"
                class="has-background-warning-dark has-text-light"
              >
                {{ kutija.index }}
              </td>
              <td
                v-else-if="kutija.name.startsWith('Legendary')"
                class="has-background-info has-text-warning"
              >
                {{ kutija.index }}
              </td>
              <td
                v-else-if="kutija.name.includes('Light')"
                class="has-background-info-light has-text-info-dark"
              >
                {{ kutija.index }}
              </td>
              <td
                v-else-if="kutija.name.includes('Crate')"
                class="has-background-warning"
              >
                <strong class="has-text-warning-dark">
                  {{ kutija.index }}
                </strong>
              </td>
              <td
                v-else-if="kutija.name.includes('Wild')"
                class="has-background-info-dark"
              >
                <strong class="has-text-warning">
                  {{ kutija.index }}
                </strong>
              </td>
              <td v-else>{{ kutija.index }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import { useRouter } from '@u3u/vue-hooks';

export default {
  setup() {
    const { route } = useRouter();
    const apiHost = process.env.VUE_APP_API_HOST;
    const chestsURL = '/player/chest/';
    const { id } = route.value.params;

    const kutije = ref([]);

    const API_URL = apiHost;

    async function getKutije() {
      const response = await fetch(API_URL + chestsURL + id);
      const json = await response.json();
      kutije.value = json;
    }

    getKutije();

    return {
      kutije,
    };
  },
};
</script>
